
import { defineComponent } from 'vue'
import DocumentExecution from '@/modules/documentExecution/main/DocumentExecution.vue'
import DocumentDetails from '@/modules/documentExecution/documentDetails/DocumentDetails.vue'
import { mapGetters } from 'vuex'

export default defineComponent({
    name: 'document-browser-cockpit-container',
    components: {
        DocumentExecution,
        DocumentDetails
    },
    props: { id: { type: String }, functionalityId: { type: String }, item: { type: Object }, parameterValuesMap: { type: Object }, tabKey: { type: String } },
    emits: ['iframeCreated', 'closeIframe', 'parametersChanged', 'closeDetails', 'documentSaved', 'close'],
    data() {
        return {
            url: '',
            mode: '',
            testIFrame: null as any,
            name: '' as string,
            loadedItem: null as any
        }
    },
    watch: {
        id() {
            this.name = this.id as string
            this.loadItem()
            this.setMode()
        },
        item() {
            this.loadItem()
            this.setMode()
        }
    },
    created() {
        this.name = this.id as string
        this.createUrl()
        this.loadItem()
        this.setMode()
    },
    activated() {
        this.loadItem()
        this.setMode()
    },
    deactivated() {
        this.mode = ''
    },
    methods: {
        ...mapGetters(['getLocale']),
        createUrl() {
            const user = (this.$store.state as any).user
            const locale = this.getLocale()
            const language = locale.split('_')[0]
            const uniqueID = user.userUniqueIdentifier
            const country = locale.split('_')[1]

            this.url = process.env.VUE_APP_HOST_URL + `/knowagecockpitengine/api/1.0/pages/edit?NEW_SESSION=TRUE&SBI_LANGUAGE=${language}&user_id=${uniqueID}&SBI_COUNTRY=${country}&SBI_ENVIRONMENT=DOCBROWSER&IS_TECHNICAL_USER=true&documentMode=EDIT&FUNCTIONALITY_ID=${this.functionalityId}`
        },
        setMode() {
            if (!this.loadedItem) return

            if (this.loadedItem.showMode === 'documentDetail') {
                this.mode = 'document-detail'
            } else if (this.loadedItem.showMode === 'execute') {
                this.mode = 'document-execution'
            } else if (this.loadedItem.showMode === 'createCockpit') {
                this.mode = 'cockpit'
                this.$emit('iframeCreated', { iframe: this.url, item: this.item })
            }
        },
        onDocumentsSaved(document: any) {
            this.$emit('documentSaved', document)
        },
        loadItem() {
            this.loadedItem = this.item
        }
    }
})
